/**
 * Fallback dashboard translations for additional / extended locales.
 * Standard locales are loaded dynamically from src/locales/dashboard/*.json.
 */
export const dashboardAdditionalTranslations: Record<string, Record<string, string>> = {};
